import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import subscribeUserToPush from './swRegistration';

ReactDOM.render(<App />, document.getElementById('root'));

// subscribeUserToPush();
